const SYSTEM_DEFAULT_DEVICE_ID = "default";

export const findDeviceById = (
  devices: MediaDeviceInfo[],
  deviceId: string | null
) => {
  if (!deviceId) {
    return null;
  }

  return devices.find((device) => device.deviceId === deviceId) ?? null;
};

export const isDeviceAvailable = (
  devices: MediaDeviceInfo[],
  deviceId: string | null
) => Boolean(findDeviceById(devices, deviceId));

export const resolveFallbackDevice = (devices: MediaDeviceInfo[]) =>
  findDeviceById(devices, SYSTEM_DEFAULT_DEVICE_ID) ?? devices[0] ?? null;

export const resolveFallbackDeviceId = (devices: MediaDeviceInfo[]) =>
  resolveFallbackDevice(devices)?.deviceId ?? null;

export const resolveSelectedDeviceId = ({
  preferredDeviceId,
  currentDeviceId,
  devices,
}: {
  preferredDeviceId: string | null;
  currentDeviceId: string | null;
  devices: MediaDeviceInfo[];
}) => {
  const preferredDevice = findDeviceById(devices, preferredDeviceId);
  if (preferredDevice) {
    return preferredDevice.deviceId;
  }

  const currentDevice = findDeviceById(devices, currentDeviceId);
  if (currentDevice) {
    return currentDevice.deviceId;
  }

  return resolveFallbackDeviceId(devices);
};
